import { MetaDataWaterPrivacyStatus } from './getWaterPrivacyStatusFromMetadata';

export const getFishingForbidden = (waterPrivacyStatus: MetaDataWaterPrivacyStatus): boolean => {
  return waterPrivacyStatus === 'danger';
};
